/* eslint-disable no-unused-vars */
import DokanOrderCard from '../card/DokanOrderCard';
import propic from '../../assets/images/profileImage.svg';
import mail from '../../assets/images/mail.svg';
import ip from '../../assets/images/ip.svg';
import receiver from '../../assets/images/receiver.svg';
import pointer from '../../assets/images/pointer.svg';

function CustomerContact({ singleOrderData }) {
    return (
        <>
            <div>
                <DokanOrderCard hasTitle Title="Customer's Contact" hasDivider>
                    <div className="px-30px pb-6  grid grid-cols-1 md:grid-cols-2">
                        <div className="col-span-full">
                            <div className="flex justify-start items-center">
                                <div className="h-12 w-12 rounded-full">
                                    <img
                                        src={propic}
                                        alt={propic}
                                        className="h-full w-full rounded-full"
                                    />
                                </div>
                                <div className="font-extrabold pl-4">
                                    {`${singleOrderData?.billing?.first_name || ''} ${
                                        singleOrderData?.billing?.last_name || ''
                                    }`}
                                </div>
                            </div>
                        </div>
                        <div className="col-span-full pt-5">
                            <div className="relative">
                                <div className="font-semibold text-light_gray flex justify-start items-center flex-grow-1 ">
                                    <div className="flex-grow-4">Billing to</div>
                                    <div className="flex-grow-3">Shipping to</div>
                                </div>
                            </div>
                            <div className="flex justify-start items-center flex-grow-6 gap-16">
                                <div className="flex-grow-3">
                                    <div className="flex gap-3 justify-start items-start pt-3">
                                        <div className="h-5 w-8 self-start">
                                            <img
                                                src={pointer}
                                                alt={pointer}
                                                className="h-full w-full rounded-full"
                                            />
                                        </div>
                                        <div>
                                            {`${singleOrderData?.billing?.address_1 || ''}, ${
                                                singleOrderData?.billing?.city || ''
                                            }, ${singleOrderData?.billing?.country || ''}`}
                                        </div>
                                    </div>
                                    <div className="flex gap-3 justify-start items-start pt-3">
                                        <div className="h-5 w-8 self-start">
                                            <img src={mail} alt={mail} className="h-full w-full" />
                                        </div>
                                        <div>{singleOrderData?.billing?.email || ''}</div>
                                    </div>
                                    <div className="flex gap-3 justify-start items-start pt-3">
                                        <div className="h-5 w-8 self-start">
                                            <img
                                                src={receiver}
                                                alt={receiver}
                                                className="h-full w-full rounded-full"
                                            />
                                        </div>
                                        <div>{singleOrderData?.billing?.phone || ''}</div>
                                    </div>
                                    <div className="flex gap-3 justify-start items-start pt-3">
                                        <div className="h-5 w-8 self-start">
                                            <img src={ip} alt={ip} className="h-full w-full" />
                                        </div>
                                        <div>
                                            {singleOrderData?.billing?.customer_ip_address || ''}
                                        </div>
                                    </div>
                                </div>

                                <div className="flex-grow-3">
                                    <div className="flex gap-3 justify-start items-start pt-3">
                                        <div className="h-5 w-8 self-start">
                                            <img
                                                src={pointer}
                                                alt={pointer}
                                                className="h-full w-full rounded-full"
                                            />
                                        </div>
                                        <div>{`${singleOrderData?.shipping?.address_1 || ''} ${
                                            singleOrderData?.billing?.city || ''
                                        } ${singleOrderData?.billing?.country || ''}`}</div>
                                    </div>
                                    <div className="flex gap-3 justify-start items-start pt-3">
                                        <div className="h-5 w-8 self-start">
                                            <img src={mail} alt={mail} className="h-full w-full" />
                                        </div>
                                        <div>{singleOrderData?.billing?.phone || ''}</div>
                                    </div>
                                    <div className="flex gap-3 justify-start items-start pt-3">
                                        <div className="h-5 w-8 self-start">
                                            <img
                                                src={receiver}
                                                alt={receiver}
                                                className="h-full w-full rounded-full"
                                            />
                                        </div>
                                        <div>{singleOrderData?.billing?.phone || ''}</div>
                                    </div>
                                    <div className="flex gap-3 justify-start items-start pt-3">
                                        <div className="h-5 w-8 self-start">&nbsp;</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </DokanOrderCard>
            </div>
            {/** end customer contact card */}
        </>
    );
}

export default CustomerContact;
